import { FeatureToggles, Vertragsoptionen, ZuersZoneEnum } from '@ps20-frontend/frontend-models';

export interface ExtremwetterUWProcessQuery {
  elementarSelbstbehaltId: ZuersZoneEnum;
  activateElementar: boolean;
  flutzone: number;
  featureToggles: FeatureToggles;
  vorschaedenVorhanden: boolean;
  vertragsoptionen: Vertragsoptionen;
  elementarVorschadenCountFromRisikoortService: number;
  risikoortZuerszone: number;
  elementarVorschaedenCount: number;
  plzRequiresUw?: boolean;
}

export const isExtremwetterUWProcessNecessary = (
  values: ExtremwetterUWProcessQuery,
): boolean => {
  return (
    isExtremwetterUWProcessNecessaryNoVorschaeden(values) ||
    isExtremwetterUWProcessNecessaryWithVorschaeden(values) ||
    isExtremwetterUWProcessNecessaryForPlzRequiringUw(values)
  );
};

export const isExtremwetterUWProcessNecessaryForPlzRequiringUw = (
  extremwetterUWProcessQuery: ExtremwetterUWProcessQuery,
): boolean => {
  return (
    extremwetterUWProcessQuery.elementarSelbstbehaltId === ZuersZoneEnum.DREI &&
    Boolean(extremwetterUWProcessQuery.plzRequiresUw)
  );
};

export const isExtremwetterUWProcessNecessaryNoVorschaeden = (
  extremwetterUWProcessQuery: ExtremwetterUWProcessQuery,
): boolean => {
  const isNeugeschaeftOrErsatzgeschaeft =
    !extremwetterUWProcessQuery.vertragsoptionen?.beibehalten;
  if (extremwetterUWProcessQuery.elementarSelbstbehaltId !== ZuersZoneEnum.VIER) {
    return false;
  }
  return (
    isNeugeschaeftOrErsatzgeschaeft ||
    (isHoechsteZuersZonePruefung(
      extremwetterUWProcessQuery.elementarSelbstbehaltId,
      extremwetterUWProcessQuery.activateElementar,
    ) &&
      extremwetterUWProcessQuery.flutzone !== 1)
  );
};

export const isExtremwetterUWProcessNecessaryWithVorschaeden = (
  extremwetterUWProcessQuery: ExtremwetterUWProcessQuery,
): boolean => {
  const { elementarSelbstbehaltId, activateElementar, flutzone, elementarVorschaedenCount } =
    extremwetterUWProcessQuery;

  const hasVorschaeden = elementarVorschaedenCount > 0;

  const isZoneVierMitFlutzone =
    isHoechsteZuersZonePruefung(elementarSelbstbehaltId, activateElementar) &&
    flutzone === 1 &&
    hasVorschaeden;

  const isZoneDreiMitVorschaeden = elementarSelbstbehaltId === ZuersZoneEnum.DREI && hasVorschaeden;

  return (
    isZoneVierMitFlutzone ||
    isZoneDreiMitVorschaeden ||
    isExtremwetterUWProcessNecessaryWithVorschadenInReplacement(extremwetterUWProcessQuery)
  );
};

export const isHoechsteZuersZonePruefung = (
  elementarSelbstbehaltId: ZuersZoneEnum,
  activateElementar: boolean,
): boolean => {
  return elementarSelbstbehaltId === ZuersZoneEnum.VIER && !activateElementar;
};

export const isExtremwetterUWProcessNecessaryWithVorschadenInReplacement = (
  extremwetterUWProcessQuery: ExtremwetterUWProcessQuery,
): boolean => {
  const ersatzgeschaeft =
    extremwetterUWProcessQuery.vertragsoptionen.vorvertragsNummern?.length > 0 &&
    !extremwetterUWProcessQuery.vertragsoptionen.beibehalten;
  const areVorschaedenVorhanden =
    extremwetterUWProcessQuery.elementarVorschaedenCount > 0 ||
    extremwetterUWProcessQuery.elementarVorschadenCountFromRisikoortService > 0;
  return Boolean(
    ersatzgeschaeft &&
      areVorschaedenVorhanden &&
      extremwetterUWProcessQuery.risikoortZuerszone === 3,
  );
};
